import { db } from 'firebase/firebase';
import { deleteDoc, doc, getDoc } from 'firebase/firestore';
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import { errorNotification } from 'appRedux/actions';

import { FSCollections } from '@src/constants/database';

import {
  userFetchError,
  userFetchSuccess,
  userRemoveFetchError,
  userRemoveFetchSuccess,
  USR_FETCH,
  USR_REMOVE_FETCH,
} from '../actions/user';

const userFetchRequest = async (organizationId, userId) =>
  getDoc(doc(db, FSCollections.ORGANIZATIONS, organizationId, FSCollections.USERS, userId)).then(
    snapshot => snapshot.data(),
  );

function* userFetch({ payload: { organizationId, userId } }) {
  try {
    const response = yield call(userFetchRequest, organizationId, userId);
    yield put(userFetchSuccess(response));
  } catch (error) {
    yield put(userFetchError(error));
    yield put(errorNotification(error.toString()));
  }
}

export function* fetchUser() {
  yield takeEvery(USR_FETCH, userFetch);
}

const userRemoveFetchRequest = async (organizationId, userId) =>
  deleteDoc(doc(db, FSCollections.ORGANIZATIONS, organizationId, FSCollections.USERS, userId));

function* userRemoveFetch({ payload: { organizationId, userId, onSuccess } }) {
  try {
    const response = yield call(userRemoveFetchRequest, organizationId, userId);
    yield put(userRemoveFetchSuccess(response));
    if (onSuccess) yield call(onSuccess);
  } catch (error) {
    yield put(userRemoveFetchError(error));
    yield put(errorNotification(error.toString()));
  }
}

export function* fetchUserRemove() {
  yield takeEvery(USR_REMOVE_FETCH, userRemoveFetch);
}

export default function* rootSaga() {
  yield all([fork(fetchUser), fork(fetchUserRemove)]);
}
